import script from "./Bread.vue?vue&type=script&lang=ts&setup=true"
export * from "./Bread.vue?vue&type=script&lang=ts&setup=true"

import "./Bread.vue?vue&type=style&index=0&id=57e6e614&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57e6e614"]])

export default __exports__